import { Box, Button, Divider, Heading, Link, Text, useDisclosure } from '@chakra-ui/react'
import { Controller, useForm } from 'react-hook-form'
import React, { useContext } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ActionModal, AuthLayout } from '../components'
import { ControlledInput, Input } from '../components/form'
import { ROUTES } from '../contants'
import { AuthContext, LOGIN } from '../context/auth/index.js'
import useResetStore from '../state/Reset.store'
import { EMAIL_OR_PHONE, removeHover, PIN } from '../utils/validations'

const Login = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { dispatch } = useContext(AuthContext)
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, touchedFields, isValid },
    watch
  } = useForm({
    mode: 'onChange',
    defaultValues: { username: '', pin: '' }
  })

  const [login, loading, errorMessage] = useResetStore((state) => [
    state.login,
    state.loading,
    state.errorMessage
  ])

  const onSubmit = async (values: any) => {
    try {
      const data = await login(values)
      dispatch({ type: LOGIN, payload: { ...data, user: { ...data.user, bvn: null } } })
    } catch (error: any) {
      onOpen()
    }
  }

  return (
    <AuthLayout>
      <Box as="form" onSubmit={handleSubmit(onSubmit)}>
        <Heading
          fontFamily="'Poppins', sans-serif"
          lineHeight="1.5"
          fontSize="2.4rem"
          mb="3.2rem"
          color="black">
          Login
        </Heading>

        <Input
          isValid={watch('username') && touchedFields.username && !errors.username && true}
          isError={touchedFields.username && errors.username && errors.username.message}
          label="Email or Phone"
          id="username"
          value={watch('username')}
          formHook={register('username', EMAIL_OR_PHONE)}
        />

        <Controller
          control={control}
          rules={PIN}
          name="pin"
          render={({ field }) => (
            <ControlledInput
              isValid={watch('pin') && !errors.pin && true}
              isError={errors.pin && errors.pin.message}
              type="password"
              label="PIN"
              id="pin"
              inputMode="numeric"
              value={field.value}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value))) {
                  e.preventDefault()
                  return
                }
                if (e.target.value.length > 6) {
                  e.preventDefault()
                  return
                }
                field.onChange(e)
              }}
            />
          )}
        />

        <Button
          isLoading={loading}
          type="submit"
          isDisabled={!isValid}
          mt="0.5rem"
          mb="2.4rem"
          isFullWidth
          variant="blue">
          Login
        </Button>
        <Link
          fontWeight="500"
          color="brand.blue"
          as={RouterLink}
          d="block"
          mb="8.7rem"
          textAlign="center"
          to={ROUTES.resetPassword}
          {...removeHover}>
          Forgot PIN?
        </Link>

        <Divider mb="2rem" />
        <Text textAlign="center">
          Get Started{' '}
          <Link
            fontWeight="500"
            color="brand.blue"
            as={RouterLink}
            to={ROUTES.insurance}
            {...removeHover}>
            Buy Insurance
          </Link>
        </Text>
      </Box>

      <ActionModal
        error
        message={errorMessage || 'An Error Occured'}
        isOpen={isOpen}
        onClose={onClose}
      />
    </AuthLayout>
  )
}

export { Login }
